/*eslint-disable */

import activeUserList from '../active-users-list/index.vue';
import carousel from 'vue-owl-carousel';
import deactivatedUserList from '../deactivated-users-list/index.vue';
import guestUserList from '../guest-users-list/index.vue';
import signupUsersList from '../signup-users-list/index.vue';
import userLogList from '../users-log-list/index.vue';

const $ = window.jQuery = require('jquery'); 
export default {
  name: 'all-user-list',
  components: {
    carousel,
    'active-user-list' : activeUserList,
    'deactivated-user-list' : deactivatedUserList,
    'user-log-list' : userLogList,
    'guest-user-list' : guestUserList,
    'signup-users-list' : signupUsersList
  },
  props: [],
  data () {
    return {
      singupUserListToggle:true,
      activeUserListToggle:true,
      deactiveUserListToggle:true,
      userFilterInfoPopupState:false,
      userFilterInfoPopupStateClass:false,
      userFilterInfoData:'',
      filterTabsChangedState:'admin_access'
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    filterTabsChangesMethod(arg){
      this.filterTabsChangedState = arg;
      $('.total_count_box').removeClass('active');
      $('#filtered' + arg).addClass('active');
    },
    userFiltersInfoPopupMethod(data){
      this.userFilterInfoData = data
      $(window).scrollTop(0);
      this.userFilterInfoPopupState = true
      document.body.classList.add('body_right_scroll_remove')
      setTimeout(() => {
        this.userFilterInfoPopupStateClass = true
      }, 10);
    },
    clickedOutside() {
      this.userFilterInfoPopupStateClass = false
      setTimeout(() => {
        this.userFilterInfoPopupState = false
        document.body.classList.remove('body_right_scroll_remove')
        this.userFilterInfoData = ''
      }, 600);
    },
    singupUserListMethod(){
      if(this.singupUserListToggle){
        this.singupUserListToggle = false
      }else{
        this.singupUserListToggle = true
      }
    },
    activeUserListMethod(){
      if(this.activeUserListToggle){
        this.activeUserListToggle = false
      }else{
        this.activeUserListToggle = true
      }
    },
    deactiveUserListMethod(){
      if(this.deactiveUserListToggle){
        this.deactiveUserListToggle = false
      }else{
        this.deactiveUserListToggle = true
      }
    },
  },
  watch:{
  },
  beforeCreate: function() {
    // $('body').addClass('sidebar_collapsed')
  },
  beforeRouteLeave: function(to, from, next) {
      $("body").removeClass("body_right_scroll_remove");
      document.body.classList.remove('body_right_scroll_remove')
    next();
  },
}